import { supabase } from './supabase'
import { getTenantHeader } from './api-interceptor'

export async function getAuthToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session) throw new Error('Usuário não autenticado')
  return session.access_token
}

export function getApiUrl(): string {
  const apiUrl = import.meta.env.VITE_API_URL
  if (!apiUrl) throw new Error('VITE_API_URL não está configurada')
  return apiUrl
}

export async function getHeaders(): Promise<Record<string, string>> {
  return {
    Authorization: `Bearer ${await getAuthToken()}`,
    ...getTenantHeader(),
  }
}

export async function handleApiError(response: Response, defaultMessage: string): Promise<never> {
  const errorText = await response.text()
  let error: { message?: string; error?: string; details?: string }
  try {
    error = JSON.parse(errorText)
  } catch {
    error = { message: errorText || 'Erro desconhecido' }
  }
  const message = error.details ?? error.message ?? error.error ?? defaultMessage
  throw new Error(message)
}
